<div fxLayout="column">
  <app-page-header [banner]="false"
                   [section]="'Brand information'"
                   [title]="'Manage your brand profile'"
                   [description]="'On this settings page you can see your general brand information. You can update your details at any time to improve your image and other communications.'">
  </app-page-header>

  <div fxLayout="column" class="page-content page-padding full-screen-height-page-default">
    <div fxFlexOffset="10px" fxLayoutGap="15px" fxLayout="row" fxLayoutAlign="start center">
      <span class="subtitle-default">Brand Information</span>
      <button (click)="toggleEdit()" *ngIf="!edit" [disabled]="loader.loading$ | async" class="button-action"
              mat-flat-button>
        <div class="button-text">Update</div>
      </button>
      <button (click)="saveUpdatesToBrandInformation()" *ngIf="edit" [disabled]="loader.loading$ | async"
              class="button-action" mat-flat-button>
        <div class="button-text">Submit</div>
      </button>
      <button (click)="toggleEdit()" *ngIf="edit" [disabled]="loader.loading$ | async"
              class="button-action-cancel" mat-flat-button>
        <div class="button-text">Cancel</div>
      </button>
    </div>

    <div class="full-width" fxLayout="row" fxLayoutGap="20px" fxFlexOffset="30px">
      <div class="info-card" fxLayout="column">
        <span class="heading-default">General information</span>
        <div [formGroup]="retailerForm" fxFlexOffset="20px" fxLayout="row" fxLayoutGap="15px">
          <mat-form-field class="custom-text-autofill" appearance="outline" floatLabel="always">
            <mat-label>System ID</mat-label>
            <input matInput type="text" [value]="this.currentRetailer?.id!.toString()" disabled/>
          </mat-form-field>
        </div>
        <div fxLayout="row" [formGroup]="retailerForm" fxLayoutGap="15px" fxFlexOffset="20px">
          <mat-form-field [ngClass]="edit ? 'custom-text-field' : 'custom-text-autofill'"
                          appearance="outline" floatLabel="always" fxFlex="50">
            <mat-label>Company Name</mat-label>
            <input matInput type="text" formControlName="companyName"/>
          </mat-form-field>
          <mat-form-field [ngClass]="edit ? 'custom-text-field' : 'custom-text-autofill'"
                          appearance="outline" floatLabel="always" fxFlex="50" hideRequiredMarker>
            <mat-label>Website</mat-label>
            <input formControlName="websiteUrl" matInput type="text"/>
          </mat-form-field>
        </div>
        <div [formGroup]="retailerForm" fxFlexOffset="20px" fxLayout="row" fxLayoutGap="15px">
          @if (offeringUuid) {
            <div class="full-width industry-select-wrapper" fxLayout="column">
              <mat-label class="body-1-default industry-select-label">Industries</mat-label>
              <app-industry-select class="full-width industry-select-component"
                                   [offeringUuid]="offeringUuid"
                                   formControlName="industries"
                                   [disabled]="!edit">
              </app-industry-select>
            </div>

          }

          <mat-form-field [ngClass]="edit ? 'custom-text-field' : 'custom-text-autofill'"
                          appearance="outline" floatLabel="always" fxFlex="50">
            <mat-label>Physical Address</mat-label>
            <input (onAutocompleteSelected)="onAddressAutocompleteSelected($event)" (onLocationSelected)="onAddressLocationSelected($event)"
                   formControlName="physicalAddress"
                   matGoogleMapsAutocomplete
                   matInput
                   type="text"/>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="full-width" fxFlexOffset="30px" fxLayout="row" fxLayoutGap="20px">
      <app-retailer-contacts class="full-width"></app-retailer-contacts>

    </div>
    <div class="full-width" fxFlexOffset="30px" fxLayout="column" fxLayoutGap="20px">
      <app-social-media #socialMediaComponent class="full-width"></app-social-media>
    </div>
  </div>

</div>
